module.exports = __webpack_public_path__ + "boxed-bg.7799dece2c79854f63f0.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/assets/images/boxed-bg.jpg
// module id = ../../../../../src/assets/images/boxed-bg.jpg
// module chunks = styles